// Chakra imports
import {
  Flex,
  Stat,
  StatLabel,
  StatNumber,
  useColorModeValue,
  Text,
} from "@chakra-ui/react";
// Custom components
import Card from "components/card/Card.js";
// Custom icons
import React from "react";

export default function Default(props) {
  const { startContent, endContent, name, growth, value, valuePreviousMonth, subLines, nameFontSize, nameColor } = props;
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const textColorSecondary = "secondaryGray.600";
  const textColorPreviousMonth = useColorModeValue("secondaryGray.500", "secondaryGray.400");

  return (
    <Card py='15px'>
      <Flex
        my='auto'
        h='100%'
        align={{ base: "center", xl: "start" }}
        justify={{ base: "center", xl: "center" }}>
        {startContent}

        <Stat my='auto' ms={startContent ? "18px" : "0px"}>
          <StatLabel
            lineHeight='1.3'
            color={ nameColor ? nameColor : textColorSecondary}
            fontSize={nameFontSize ? nameFontSize : "13px"}
            fontWeight='500'
            letterSpacing='0'>
            {name}
          </StatLabel>
          <StatNumber
            color={textColor}
            fontSize={{ base: "28px", md: "32px" }}
            fontWeight='700'
            lineHeight='1.1'
            letterSpacing='-0.02em'
            fontFeatureSettings='"tnum" on, "lnum" on'>
            {value}
          </StatNumber>

          {valuePreviousMonth && (
            <Text
              color={textColorPreviousMonth}
              fontSize="13px"
              fontWeight="500"
              lineHeight="1.3"
              mt="6px"
            >
              {`חודש קודם: ${valuePreviousMonth}`}
            </Text>
          )}

          {subLines && subLines.map((line, i) => (
            <Text
              key={i}
              color={textColorPreviousMonth}
              fontSize="13px"
              fontWeight="500"
              lineHeight="1.3"
              mt="4px"
            >
              {line}
            </Text>
          ))}

          {growth ? (
            <Flex align='center'>
              <Text color='green.500' fontSize='12px' fontWeight='600' me='5px'>
                {growth}
              </Text>
              <Text color='secondaryGray.600' fontSize='12px' fontWeight='500'>
                since last month
              </Text>
            </Flex>
          ) : null}
        </Stat>
        <Flex ms='auto' w='max-content'>
          {endContent}
        </Flex>
      </Flex>
    </Card>
  );
}
